// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Qgrqz","empty":"ModalGraph_empty__1AnhC"};